/** A spinner for a whole screen (before the shell exists) or, `inline`, for the page area inside the shell. */
export function PageSpinner({ inline = false }: { inline?: boolean }) {
  return (
    <div
      className={`flex items-center justify-center ${inline ? 'min-h-[50vh]' : 'h-screen'}`}
      role="status"
      aria-label="Loading"
    >
      <div className="border-line border-t-blue h-6 w-6 animate-spin rounded-full border-2" />
    </div>
  );
}
